import React from 'react';
import PropTypes from 'prop-types';
import { FlagBlock } from 'anf-core-react';
import AddressCard from '../../AddressCard/AddressCard';

function SavedAddressCard({ address, isCountryFlagVisible }) {
  if (!address) {
    return null;
  }
  return (
    <div data-testid="saved-address-card">
      <AddressCard address={address} />
      {isCountryFlagVisible && address.country
        && (
          <FlagBlock
            countryCode={address.country}
            countryName={address.country}
          />
        )}
    </div>
  );
}

SavedAddressCard.propTypes = {
  address: PropTypes.shape({
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    sameDayStoreId: PropTypes.string,
    addressId: PropTypes.string,
    country: PropTypes.string,
    isAddressVerified: PropTypes.bool,
    email: PropTypes.string,
    isBillingAllowed: PropTypes.bool,
    isDefaultBilling: PropTypes.bool,
    isDefaultShipping: PropTypes.bool,
    isShippingAllowed: PropTypes.bool,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    orgName: PropTypes.string,
    pickUpStoreId: PropTypes.string,
    poBox: PropTypes.bool,
    title: PropTypes.string,
    zone: PropTypes.string,
    district: PropTypes.string,
    prefecture: PropTypes.string,
  }),
  isCountryFlagVisible: PropTypes.bool,
};

SavedAddressCard.defaultProps = {
  isCountryFlagVisible: false,
  address: {
    address1: '',
    address2: '',
    city: '',
    state: '',
    postalCode: '',
    isCountryFlagVisible: false,
    firstName: '',
    lastName: '',
    sameDayStoreId: '',
    country: '',
    isAddressVerified: false,
    email: '',
    isBillingAllowed: false,
    isDefaultBilling: false,
    isDefaultShipping: false,
    isShippingAllowed: false,
    orgName: '',
    pickUpStoreId: '',
    poBox: false,
    title: '',
    zone: '',
    district: '',
    prefecture: '',
  },
};
export default SavedAddressCard;
